import { defineRouting } from "next-intl/routing";

export const labels = [
    {
        id: "fr",
        label: "🇫🇷 Français",
    },
    {
        id: "en",
        label: "🇬🇧 English",
    },
];

export const routing = defineRouting({
    // A list of all locales that are supported
    locales: ["fr", "en"],

    // Used when no locale matches
    defaultLocale: "fr",

    // Sans maxAge, next-intl pose un cookie de session : le choix manuel
    // de langue serait perdu à la fermeture du navigateur.
    localeCookie: {
        maxAge: 60 * 60 * 24 * 365,
    },

    // Paths
    pathnames: {
        // La racine s'écrit pareil dans les deux langues, mais elle doit
        // figurer ici : sans elle, `<Link href="/">` sort des chemins typés.
        "/": {
            fr: "/",
            en: "/",
        },
        "/courses": {
            fr: "/formations",
            en: "/courses",
        },
        "/code/python": {
            fr: "/code/python",
            en: "/code/python",
        },
        "/course/[slug]": {
            fr: "/formations/[slug]",
            en: "/courses/[slug]",
        },
        "/course/[slug]/[partNumber]/[sessionNumber]": {
            fr: "/formations/[slug]/[partNumber]/[sessionNumber]",
            en: "/courses/[slug]/[partNumber]/[sessionNumber]",
        },
        "/course/le-programme-rocket/dashboard": {
            fr: "/formations/le-programme-rocket/tableau-de-bord",
            en: "/courses/the-rocket-program/dashboard",
        },
        "/course/formation-angular": {
            fr: "/formations/formation-angular",
            en: "/courses/formation-angular",
        },
        "/course/formation-html": {
            fr: "/formations/formation-html",
            en: "/courses/formation-html",
        },
        "/course/formation-javascript": {
            fr: "/formations/formation-javascript",
            en: "/courses/formation-javascript",
        },
        "/course/formation-nextjs": {
            fr: "/formations/formation-nextjs",
            en: "/courses/formation-nextjs",
        },
        "/course/formation-nodejs": {
            fr: "/formations/formation-nodejs",
            en: "/courses/formation-nodejs",
        },
        "/course/formation-python": {
            fr: "/formations/formation-python",
            en: "/courses/formation-python",
        },
        "/course/formation-react": {
            fr: "/formations/formation-react",
            en: "/courses/formation-react",
        },
        "/course/formation-symfony": {
            fr: "/formations/formation-symfony",
            en: "/courses/formation-symfony",
        },
        "/course/formation-typescript": {
            fr: "/formations/formation-typescript",
            en: "/courses/formation-typescript",
        },
        "/course/mettre-son-site-en-ligne-facilement": {
            fr: "/formations/mettre-son-site-en-ligne-facilement",
            en: "/courses/mettre-son-site-en-ligne-facilement",
        },
        "/course/formation-bootstrap": {
            fr: "/formations/formation-bootstrap",
            en: "/courses/formation-bootstrap",
        },
        "/course/formation-claude-code": {
            fr: "/formations/formation-claude-code",
            en: "/courses/formation-claude-code",
        },
        "/course/formation-claude-cowork": {
            fr: "/formations/formation-claude-cowork",
            en: "/courses/formation-claude-cowork",
        },
        "/course/formation-claude-design": {
            fr: "/formations/formation-claude-design",
            en: "/courses/formation-claude-design",
        },
        "/course/formation-hermes-agent": {
            fr: "/formations/formation-hermes-agent",
            en: "/courses/formation-hermes-agent",
        },
        "/course/formation-codex": {
            fr: "/formations/formation-codex",
            en: "/courses/formation-codex",
        },
        "/course/formation-git-github": {
            fr: "/formations/formation-git-github",
            en: "/courses/formation-git-github",
        },
        "/course/formation-mvc": {
            fr: "/formations/formation-mvc",
            en: "/courses/formation-mvc",
        },
        "/course/formation-n8n": {
            fr: "/formations/formation-n8n",
            en: "/courses/formation-n8n",
        },
        "/course/formation-php": {
            fr: "/formations/formation-php",
            en: "/courses/formation-php",
        },
        "/course/formation-react-native": {
            fr: "/formations/formation-react-native",
            en: "/courses/formation-react-native",
        },
        "/course/formation-sass": {
            fr: "/formations/formation-sass",
            en: "/courses/formation-sass",
        },
        "/course/formation-tailwindcss": {
            fr: "/formations/formation-tailwindcss",
            en: "/courses/formation-tailwindcss",
        },
        "/course/maitriser-son-nas-synology": {
            fr: "/formations/maitriser-son-nas-synology",
            en: "/courses/maitriser-son-nas-synology",
        },
        "/accelerators": {
            fr: "/accelerateurs",
            en: "/accelerators",
        },
        "/accelerators/[slug]": {
            fr: "/accelerateurs/[slug]",
            en: "/accelerators/[slug]",
        },
        "/accelerators/[slug]/dashboard": {
            fr: "/accelerateurs/[slug]/tableau-de-bord",
            en: "/accelerators/[slug]/dashboard",
        },
        "/accelerators/[slug]/entry-document": {
            fr: "/accelerateurs/[slug]/justificatif-entree-en-formation",
            en: "/accelerators/[slug]/entry-document",
        },
        "/accelerators/[slug]/onboarding-handbook": {
            fr: "/accelerateurs/[slug]/livret-d-accueil",
            en: "/accelerators/[slug]/onboarding-handbook",
        },
        "/accelerators/[slug]/notebook": {
            fr: "/accelerateurs/[slug]/carnet",
            en: "/accelerators/[slug]/notebook",
        },
        "/accelerators/[slug]/[moduleNumber]/[partNumber]/[sessionNumber]": {
            fr: "/accelerateurs/[slug]/[moduleNumber]/[partNumber]/[sessionNumber]",
            en: "/accelerators/[slug]/[moduleNumber]/[partNumber]/[sessionNumber]",
        },
        "/tools": {
            fr: "/outils",
            en: "/tools",
        },
        // Déclarée avant [slug] pour la lisibilité : un segment fixe l'emporte
        // de toute façon sur le segment dynamique.
        "/tools/my-situation": {
            fr: "/outils/ma-situation",
            en: "/tools/my-situation",
        },
        // La page où mène le lien de connexion reçu par e-mail
        // (app/api/tools/login-link).
        "/tools/sign-in": {
            fr: "/outils/connexion",
            en: "/tools/sign-in",
        },
        "/tools/[slug]": {
            fr: "/outils/[slug]",
            en: "/tools/[slug]",
        },
        "/glossaries": {
            fr: "/glossaires",
            en: "/glossaries",
        },
        "/glossaries/[slug]": {
            fr: "/glossaires/[slug]",
            en: "/glossaries/[slug]",
        },
        "/glossaries/[slug]/[termSlug]": {
            fr: "/glossaires/[slug]/[termSlug]",
            en: "/glossaries/[slug]/[termSlug]",
        },
        "/mentoring": {
            fr: "/mentorat",
            en: "/mentoring",
        },
        "/mentoring/[pseudo]": {
            fr: "/mentorat/[pseudo]",
            en: "/mentoring/[pseudo]",
        },
        "/rdv/[token]": {
            fr: "/rdv/[token]",
            en: "/book/[token]",
        },
        "/mentor": {
            fr: "/mentor",
            en: "/mentor",
        },
        "/writer": {
            fr: "/redacteur",
            en: "/writer",
        },
        "/writer/files": {
            fr: "/redacteur/fichiers",
            en: "/writer/files",
        },
        "/writer/articles/[slug]": {
            fr: "/redacteur/articles/[slug]",
            en: "/writer/articles/[slug]",
        },
        "/r/[slug]": {
            fr: "/r/[slug]",
            en: "/r/[slug]",
        },
        "/instructor": {
            fr: "/formateur",
            en: "/instructor",
        },
        "/instructor/courses/[slug]": {
            fr: "/formateur/formations/[slug]",
            en: "/instructor/courses/[slug]",
        },
        "/articles": {
            fr: "/articles",
            en: "/articles",
        },
        "/reps": {
            fr: "/reps",
            en: "/reps",
        },
        "/reps/[lessonSlug]": {
            fr: "/reps/[lessonSlug]",
            en: "/reps/[lessonSlug]",
        },
        "/reps/path/[trackSlug]": {
            fr: "/reps/parcours/[trackSlug]",
            en: "/reps/path/[trackSlug]",
        },
        // Porte d'entree de l'app : /go/reps pointe ici. Volontairement hors
        // de /reps, sinon la route attrape-tout /reps/[lessonSlug] devrait
        // reserver un slug de lecon pour elle.
        "/reps-app": {
            fr: "/reps-app",
            en: "/reps-app",
        },
        "/reading-list": {
            fr: "/liste-de-lecture",
            en: "/reading-list",
        },
        "/leagues": {
            fr: "/ligues",
            en: "/leagues",
        },
        "/call/[token]": {
            fr: "/appel/[token]",
            en: "/call/[token]",
        },
        "/certifications/[certificationNumber]": {
            fr: "/certifications/[certificationNumber]",
            en: "/certifications/[certificationNumber]",
        },
        "/messenger": {
            fr: "/messagerie",
            en: "/messenger",
        },
        "/u/[pseudo]": {
            fr: "/u/[pseudo]",
            en: "/u/[pseudo]",
        },
        "/account": {
            fr: "/compte",
            en: "/account",
        },
        "/affiliate": {
            fr: "/affiliation",
            en: "/affiliate",
        },
        "/account/invoice/[orderNumber]": {
            fr: "/compte/factures/[orderNumber]",
            en: "/account/invoices/[orderNumber]",
        },
        "/series/[slug]": {
            fr: "/series/[slug]",
            en: "/series/[slug]",
        },
        "/series/[slug]/[seasonNumber]/[episodeNumber]": {
            fr: "/series/[slug]/[seasonNumber]/[episodeNumber]",
            en: "/series/[slug]/[seasonNumber]/[episodeNumber]",
        },
        "/login": {
            fr: "/connexion",
            en: "/login",
        },
        "/signup": {
            fr: "/inscription",
            en: "/signup",
        },
        "/verify-account": {
            fr: "/verification",
            en: "/verify-account",
        },
        "/security/forgotten-password": {
            fr: "/mot-de-passe-oublie",
            en: "/forgotten-password",
        },
        "/pricing": {
            fr: "/tarifs",
            en: "/pricing",
        },
        "/join-instructors": {
            fr: "/devenir-formateur",
            en: "/join-instructors",
        },
        "/join-mentors": {
            fr: "/devenir-mentor",
            en: "/join-mentors",
        },
        "/legal-mentions": {
            fr: "/mentions-legales",
            en: "/legal-mentions",
        },
        "/privacy": {
            fr: "/confidentialite",
            en: "/privacy",
        },
        "/internal-rules": {
            fr: "/reglement-interieur",
            en: "/internal-rules",
        },
        "/tools-terms": {
            fr: "/conditions-outils",
            en: "/tools-terms",
        },
        "/tools-alert": {
            fr: "/outils-alerte",
            en: "/tools-alert",
        },
        "/support": {
            fr: "/aide",
            en: "/support",
        },
        "/events": {
            fr: "/evenements",
            en: "/events",
        },
        "/terms-of-sale": {
            fr: "/cgv",
            en: "/terms-of-sale",
        },
        "/terms-of-use": {
            fr: "/cgu",
            en: "/terms-of-use",
        },
        "/community": {
            fr: "/communaute",
            en: "/community",
        },
        "/community/discussions/[id]": {
            fr: "/communaute/discussions/[id]",
            en: "/community/discussions/[id]",
        },
        "/press": {
            fr: "/presse",
            en: "/press",
        },
        "/accelerators/rocket": {
            fr: "/accelerateurs/rocket",
            en: "/accelerators/rocket",
        },
        "/accelerators/rocket/admission": {
            fr: "/accelerateurs/rocket/admission",
            en: "/accelerators/rocket/admission",
        },
        "/accelerators/python": {
            fr: "/accelerateurs/python",
            en: "/accelerators/python",
        },
        "/accelerators/python/admission": {
            fr: "/accelerateurs/python/admission",
            en: "/accelerators/python/admission",
        },
        "/invitations/[key]": {
            fr: "/invitations/[key]",
            en: "/invitations/[key]",
        },
        "/workshops/[slug]/play": {
            fr: "/ateliers/[slug]/regarder",
            en: "/workshops/[slug]/watch",
        },
        "workshops/[slug]": {
            fr: "/ateliers/[slug]",
            en: "/workshops/[slug]",
        },
        "/workshops": {
            fr: "/ateliers",
            en: "/workshops",
        },
        "/changelog": {
            fr: "/nouveautes",
            en: "/changelog",
        },
        "/discount-code/hostinger": {
            fr: "/code-promo/hostinger",
            en: "/discount-code/hostinger",
        },
        "/resultats": {
            fr: "/resultats",
            en: "/results",
        },
        "/signalement": {
            fr: "/signalement",
            en: "/report-a-concern",
        },
    },
});
